import{a as e}from"./chunk-EI7MMDWY.js";var n=e(async s=>new Promise(t=>{setTimeout(t,s)}),"sleep");export{n as a};
